import { fetchResource, fetchOnce } from "../../util/fetch";
import { Service } from "../../service/device/setup";
import { Show } from "solid-js"
import { Spinner, Card, Button, Row, Col } from "solid-bootstrap";

export function ThemePresetPicker(props) {
    const [theme, refetchTheme] = fetchResource(() => Service.getTheme(props.theme.uuid));
    const [themeImages, isImagesLoaded, isImagesError] = fetchOnce(() => Service.listThemePresetImages());

    function isLoaded() {
        return !theme.loading && isImagesLoaded;
    }

    function makeImageOnClickHandler(bucketFile) {
        return (e) => {
            Service.getTheme(props.theme.uuid).then(myTheme => {
                const skinName = bucketFile.metadata.skin_name;
                myTheme.skin_name = skinName;
                myTheme["is_user_set_theme"] = true;
                Service.updateTheme(myTheme).then(() => {
                    const presetName = bucketFile.metadata.preset_name;
                    Service.applyThemePreset(myTheme.uuid, presetName);
                });
            });
        };
    }

    return <>
        <Show when={isLoaded()}>
            <Row g={3}>
                <For each={themeImages()}>{(img, i) =>
                    <Col sm="6" md="4" lg="3">
                        <PresetOption bucketFile={img} onClick={makeImageOnClickHandler(img)} />
                    </Col>
                }</For>
            </Row>
        </Show>
        <Show when={!isLoaded()}>
            <Spinner animation="border" />
        </Show>
    </>
}

function PresetOption(props) {
    const [imageURL, isURLLoaded, isURLError] = fetchOnce(() => Service.getBucketFileDownloadURL(props.bucketFile.uuid));
    return <>
        <Show when={isURLLoaded()}>
            <Card>
                <Card.Img variant="top" src={imageURL()} style="max-width: 18rem"></Card.Img>
                <Card.Body>
                    <Button variant="primary" onClick={props.onClick}>Apply</Button>
                </Card.Body>
            </Card>
        </Show>
        <Show when={!isURLLoaded()}>
            <Spinner animation="border" />
        </Show>
    </>

}